import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterSMSView.
 * @extends JetView
 */
export default class FilterSMSView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const id_partner = this.getParam('partner', true); // Partner ID from parameters
        const vthis = this; // Reference to the current instance

        // Filter configuration with input fields
        const filter = {
            rows: [
                {
                    margin: 10,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                            invalidMessage: _('Id is required'), // Validation message
                        },
                        {
                            view: 'combo',
                            name: 'Type',
                            id: 'FilterType', // ID for the filter type combo
                            label: _('Tipo'),
                            labelPosition: 'top',
                            value: 'null',
                            options: [], // Options will be populated dynamically
                        },
                        {
                            view: 'richselect',
                            name: 'Language',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 'null',
                            options: [
                                { id: 'null', value: _('Default') },
                                {
                                    id: 'es',
                                    value: 'español (o castellano) (ES)',
                                },
                                { id: 'en', value: 'English (EN)' },
                            ],
                            id: 'Language',
                        },
                        {
                            view: 'combo',
                            name: 'Section',
                            id: 'FilterSection', // ID for the filter section combo
                            label: _('Sección'),
                            labelPosition: 'top',
                            value: 'null',
                            options: [], // Options will be populated dynamically
                        },
                    ],
                },
            ],
        };

        // Upper section containing the filter
        const upper_section = {
            css: 'father-container',
            height: screen == 'small' ? 150 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [filter],
                },
            ],
        };

        // Button configuration
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 1 }, // Gravity for layout
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Añadir Plantilla'), // Button label
                            hidden: !devConfig.getPermAction('AddTemplate', 'Add'), // Conditional visibility
                            css: 'prm-AddTemplate',
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                this.app.callEvent('addTemplate:button', [[]]); // Event call on button click
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                $$('formFilter').setValues($$('formFilter').getCleanValues()); // Clear form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                $$('b1').collapse(); // Collapse the accordion
                                const filterdata = $$('formFilter').getValues(); // Get form values
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                vthis.app.callEvent('filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section containing filters and buttons
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formFilter', // ID for the form
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and fetches data for filters.
     */
    init() {
        const vthis = this; // Reference to the current instance
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Partner ID from parameters
        const params = {
            Partner: id_partner, // Parameters for API requests
        };

        // Fetch filter types from API
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Partners/GetTypeTemplateSMSSelect', params, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message({
                        title: _('¡Error!'),
                        type: 'alert-error',
                        text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                    });
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    resp.Data.unshift({ id: 'null', value: _('Default') }); // Add default option
                    $$('FilterType').getList().clearAll(); // Clear existing options
                    $$('FilterType').getList().parse(resp.Data); // Populate options
                    $$('FilterType').setValue('null'); // Set default value
                },
            });

        // Fetch filter sections from API
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Partners/GetSectionTemplateSMSSelect', params, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    resp.Data.unshift({ id: 'null', value: _('Default') }); // Add default option
                    $$('FilterSection').getList().clearAll(); // Clear existing options
                    $$('FilterSection').getList().parse(resp.Data); // Populate options
                    $$('FilterSection').setValue('null'); // Set default value
                },
            });

        // Adjust visibility based on screen width
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
